import { ImgHTMLAttributes } from "react"

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt?: string
  className?: string
}

export const Image = ({ src, alt = "", className, ...props }: ImageProps) => (
  <img src={`/client/img/${src}`} alt={alt} className={className} {...props} />
)
